<template lang="pug">
  include /mixins
  +b.d-control-input.relative
    d-control-static-multiselect(
      :class='{scroll: filterName === "shipment"}'
      :multiple='filterName !== "owner" ? true : false',
      :options='filter.choices || []'
      v-model='checked'
      :name='filterName'
      :searchable='filterName === "owner" ? true : false'
      :label='filterLabel'
      track-by='value'
      :placeholder='filter.label',
      @input='submit'
      :maxHeight="224"
    )
      span(
        slot="caret"
        slot-scope="{ toggle }"
        class="arrow"
        @mousedown.prevent.stop="toggle"
      )
        +b.ic.icon-arrow
    +b.label-input
      +e.SPAN.text.ds-caption.--size-12.--color-gray-light.--weight-bold {{ filter.label }}

</template>

<script>
// import { isEmpty } from '@aspectus/vue-utils'

export default {
  name: 'SimpleSelect',

  props: {
    value: {},
    filter: {},
    filterName: {},
    disabled: {
      default: false,
    },
    filterLabel: {
      default: 'label',
    },
    searchable: {
      default: true,
    },
  },

  data() {
    return {
      checked: '',
    }
  },

  watch: {
    value(nval) {
      this.checked = this.normalizeFrom(nval)
    },
  },

  mounted() {
    this.checked = this.normalizeFrom(this.value)
  },

  methods: {
    submit() {
      const val = this.normalizeTo(this.checked)
      this.$emit('input', val)
    },

    normalizeTo(value) {
      let val = value
      if (!value) return []
      if (!Array.isArray(value)) {
        val = [value]
      }
      const checked = this.filter.choices
        .filter(el => val.find(v => v.value === el.value))
        .map(el => el.value)
      return checked
    },

    normalizeFrom(value) {
      let val = value
      if (!val) return []
      if (!Array.isArray(value)) {
        val = [value]
      }
      const checked = this.filter.choices
        .filter(el => val.find(v => v === el.value))
      return checked
    },
  },
}
</script>
